module.exports = __webpack_public_path__ + "img/geofisica3_4-3_3072.6e339f5e.jpg";